import { http, HttpResponse } from 'msw';

import { getOrders, createOrder, getOrdersHistory } from '@core/order';

import { Storage } from '../storage';
import { parseUrl } from '../utils';
import { positionsStorage } from './positions';

import ordersData from '../data/order/orders.json';
import ordersHistoryData from '../data/order/orders-history.json';

type TGetOrders = HttpGet<typeof getOrders>;
type TCreateOrder = HttpGet<typeof createOrder>;
type TGetOrdersHistory = HttpGet<typeof getOrdersHistory>;

export const ordersStorage = new Storage('orders', ordersData);

export default [
  http.get<TGetOrders[0], TGetOrders[1], TGetOrders[2]>(
    parseUrl(getOrders.url),
    () => {
      const data = ordersStorage.getValue();
      return HttpResponse.json(data);
    }
  ),
  http.post<TCreateOrder[0], TCreateOrder[1], TCreateOrder[2]>(
    parseUrl(createOrder.url),
    async () => {
      // const data = await request.json();

      ordersStorage.update((prev) => {
        prev.items[1].marginSourceAssets?.push({
          type: 2,
          name: 'اهرم',
          count: 10,
          value: 10000,
        });

        return prev;
      });

      positionsStorage.update((prev) => {
        prev.items[1].marginSourceAssets.push({
          type: 3,
          name: 'ضهرم ۲۰۲۱',
          count: 6,
          value: null,
        });

        return prev;
      });

      return HttpResponse.json({} as unknown as TCreateOrder[2]);
    }
  ),
  http.get<TGetOrdersHistory[0], TGetOrdersHistory[1], TGetOrdersHistory[2]>(
    parseUrl(getOrdersHistory.url),
    () => {
      return HttpResponse.json(
        ordersHistoryData as unknown as TGetOrdersHistory[2]
      );
    }
  ),
];
